export type DocStatus = {
  label: string;
  colorScheme: string;
};

// Order of checks encodes precedence: approved > open > with-fixes > submitted > missing.
export function deriveDocStatus(doc: {
  approved: boolean;
  submitted: boolean;
  isOpenForResubmission: boolean;
  reopenHistory: { nodes: unknown[] };
}): DocStatus {
  const wasReopened = doc.reopenHistory.nodes.length > 0;

  if (doc.approved) {
    return { label: "Approved", colorScheme: "blue" };
  }
  if (doc.isOpenForResubmission) {
    return { label: "Reopened for submission", colorScheme: "orange" };
  }
  if (doc.submitted && wasReopened) {
    return { label: "Completed with fixes", colorScheme: "teal" };
  }
  if (doc.submitted) {
    return { label: "Completed", colorScheme: "green" };
  }
  return { label: "Missing", colorScheme: "gray" };
}
